import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { legalEndpoints } from '@/modules/legal/constants';
import { legalQueryKeys } from '@/modules/legal/queries/queryKeys';
import type { CandidateNoticeApi } from '@/modules/legal/types';

interface UpdateCandidateNoticeVariables {
  tenantId: string;
  notice: CandidateNoticeApi;
  enabled: boolean;
}

export const useUpdateCandidateNoticeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      tenantId,
      notice,
      enabled,
    }: UpdateCandidateNoticeVariables) => {
      const { data } = await fetchClient.PUT(legalEndpoints.candidateNotices, {
        params: { query: { tenantId } },
        body: { notice, enabled },
      });
      return data;
    },
    onSuccess: (data, { tenantId }) => {
      if (!data) return;
      queryClient.setQueryData(legalQueryKeys.candidateNotices(tenantId), {
        privacyNoticeEnabled: data.privacyNoticeEnabled,
        aiDisclosureEnabled: data.aiDisclosureEnabled,
      });
    },
  });
};
